import { createContext, useContext, useState } from "react";
import { initialTasks, generateTaskId } from "../data/tasks";

const TaskContext = createContext();

export function TaskProvider({ children }) {
  const [tasks, setTasks] = useState(initialTasks);

  const addTask = (task) => {
    const newTask = {
      ...task,
      id: generateTaskId(tasks.length),
      status: "Pending",
      technician: { name: "Unassigned" }
    };

    setTasks((prev) => [newTask, ...prev]);
  };

  return (
    <TaskContext.Provider value={{ tasks, addTask }}>
      {children}
    </TaskContext.Provider>
  );
}

export const useTasks = () => useContext(TaskContext);
